module.exports = __webpack_public_path__ + "static/pool4-63b44b83742546e0c4fd1cfac9e09c37.jpg";